// CORE
import { Form, global } from '@autoprog/core-client';

// NODE_MODULE
// TEMPLATE
import T_modal from '../../tpl/modals/Output.html';

// LIBS
import Modal from '@libs/Modal';

// PRINTER
// UTILS
// MODAL
import M_Edit from '../modals/Edit';

// CUSTOM_ELEMENT
import CE_OutputTracaForm from '../libs/customElement/OutputTracaForm';
import CE_Quantity from '@libs/customElement/Quantity';
import CE_Select2 from '@libs/customElement/Select2';

// SERVICE
import S_Product from '@services/Product/ProductService';
import S_Stock from '@services/StockService';
import S_StockEvent from '@services/StockEventService';

class Output extends Modal {
	private form: Form | null = null;

	private filters: { [key: string]: any } = {};

	private hasProduct = false;

	private selectPostinit: { [key: string]: CE_Select2 } = {};

	constructor(idProduct?: string, quantity?: number, stock?: string) {
		super({
			tpl: T_modal,
			keyboard: false,
			backdrop: 'static'
		});

		this.filters.stock = stock;

		this.hasProduct = !idProduct;

		this.on('opened', async () => {
			const N_close = this.element.querySelector('.close') as HTMLButtonElement;

			N_close.addEventListener('click', (e: MouseEvent) => {
				this.reject();

				e.stopImmediatePropagation();
				e.stopPropagation();
			});

			if (global.IS_MOBILE) {
				const N_modalDialog = this.element.querySelector('.modal-dialog') as HTMLSelectElement;
				N_modalDialog.classList.remove('modal-70');
			}

			await this.initStock();
			this.init();

			const N_form = this.element.querySelector('.modal-content') as HTMLFormElement;

			this.form = new Form(N_form);

			this.form.setData({
				quantity: 0
			});

			if (idProduct) {
				const tmpProduct = await S_Product.getInstance().getDataToSelect2ByID(idProduct);

				this.form?.setDataByName('product', tmpProduct);

				const N_oldQuantity = this.element.querySelector('#oldQuantity') as HTMLElement;

				N_oldQuantity.innerHTML = `Ancienne quantité : ${quantity || 0}`;
			}

			if (stock) {
				this.form?.setDataByName('stock', stock);
			}

			const N_save = this.element.querySelector('#save') as HTMLButtonElement;

			N_save.addEventListener('click', async () => {
				if (this.form) {
					const data = this.form.getData() as { [key: string]: any };

					data.type = 'output';

					for (const key in data.traceability) {
						if (data.traceability[key] === '') {
							delete data.traceability[key];
						}
					}

					await S_StockEvent.getInstance().save(data);

					const newQuantity = (quantity || 0) - (data.quantity as number);

					if (newQuantity < 0 && data.stock !== 'deliveryToCustomer') {
						new M_Edit(idProduct!, newQuantity!, stock!).open().then((quantity) => {
							this.resolve(quantity);
						}).catch(() => {
							this.resolve(newQuantity);
						});
					} else {
						this.resolve(newQuantity);
					}
				}
			});

			this.postInit();
		});
	}

	private async initStock() {
		const N_list = this.element.querySelector('[name="stock"]') as HTMLSelectElement;
		const data = await S_Stock.getInstance().getRealStock();

		for (const item of data) {
			const option = new Option(item.name, item._id);

			N_list.append(option);
		}
	}

	private init() {
		const N_product = this.element.querySelector('[name="product"]') as CE_Select2;
		const N_stock = this.element.querySelector('[name="stock"]') as HTMLSelectElement;

		N_product.create(this.element, { disabled: !this.hasProduct });

		const N_outputTracaForm = this.element.querySelector(CE_OutputTracaForm.tagName) as CE_OutputTracaForm;
		N_outputTracaForm.init(this.element, N_stock);

		const N_quantity = this.element.querySelector(CE_Quantity.tagName) as CE_Quantity;

		N_quantity.addEventListener('change', () => {
			this.updateButtonSave();
		});

		this.selectPostinit.product = N_product;
	}

	private postInit() {
		const N_outputTracaForm = this.element.querySelector(CE_OutputTracaForm.tagName) as CE_OutputTracaForm;
		N_outputTracaForm.postInit();

		this.selectPostinit.product.postInit();

		this.updateButtonSave();
	}

	private updateButtonSave() {
		const N_save = this.element.querySelector('#save') as HTMLButtonElement;

		const quantity = this.form?.getDataByName('quantity');

		N_save.disabled = quantity === 0 || isNaN(quantity as number);
	}
}

export default Output;
